const SVGComponent = (props) => (
  <svg
    width={14}
    height={18}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 19L14.5039 19.8682C14.8134 20.0451 15.1936 20.0438 15.5019 19.8649C15.8102 19.686 16 19.3565 16 19H15ZM1 19H0C0 19.3565 0.189758 19.686 0.498073 19.8649C0.806388 20.0438 1.18664 20.0451 1.49614 19.8682L1 19ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM8 15L8.49614 14.1318C8.18871 13.9561 7.81129 13.9561 7.50386 14.1318L8 15ZM6.20711 7.54289C5.81658 7.15237 5.18342 7.15237 4.79289 7.54289C4.40237 7.93342 4.40237 8.56658 4.79289 8.95711L6.20711 7.54289ZM7 9.75L6.2929 10.4571C6.68342 10.8476 7.31659 10.8476 7.70711 10.4571L7 9.75ZM11.2071 6.95711C11.5976 6.56658 11.5976 5.93342 11.2071 5.54289C10.8166 5.15237 10.1834 5.15237 9.7929 5.54289L11.2071 6.95711ZM14 1V19H16V1H14ZM2 19V1H0V19H2ZM1 2H15V0H1V2ZM15.4961 18.1318L8.49614 14.1318L7.50386 15.8682L14.5039 19.8682L15.4961 18.1318ZM7.50386 14.1318L0.503861 18.1318L1.49614 19.8682L8.49614 15.8682L7.50386 14.1318ZM4.79289 8.95711L6.2929 10.4571L7.70711 9.0429L6.20711 7.54289L4.79289 8.95711ZM7.70711 10.4571L11.2071 6.95711L9.7929 5.54289L6.2929 9.0429L7.70711 10.4571Z"
      fill="#7A7A83"
    />
  </svg>
)
export default SVGComponent
